module.exports = __webpack_public_path__ + "media/Video 121.b8129aa0.mp4";